<app-loader [isLoading]="isLoading"></app-loader>
<div class="d-flex justify-content-between gap-2" style="margin-bottom: 1rem;">
     <div class="d-flex">
            <input type="text" class="dp-input-control searchInput" [formControl]="searchReq"
                placeholder="Search by anything" />
        </div>
    <button class="dp-primary-btn btn-div d-flex gap-2 align-items-center" (click)="onFilterClick()">
        Filter<img src="../../../assets/filter.svg" />
    </button>
</div>
@if (!isMobile) {
@if(showReportType === 'COUNTRIES'){
<div class="table-container">
    <table class="table">
        <thead class="table-head">
            <tr>
                <th>
                    <span>State</span>
                </th>
                <th>
                    <span>Total Fcs</span>
                </th>
            </tr>
        </thead>

        <tbody class="table-body">
            @if(depositReport.length > 0){
            @for(row of depositReport; track row){
            <tr>
                @if(row?.states !== 'UNKNOWN'){
                <td (click)="onStateClick(row?.states)" class="hover-item">
                    {{row?.states}}
                </td>
                <td>
                    {{row?.totalFcs}}
                </td>
            }
            </tr>
            }
            }@else {
            <tr>
                <td colspan="5" style="text-align: center;">
                    No records found
                </td>
            </tr>
            }
        </tbody>

    </table>

</div>
}@else if(showReportType === 'STATES'){
<div class="table-container">
    <table class="table">
        <thead class="table-head">
            <tr>
                <th>
                    <span>District</span>
                </th>
                <th>
                    <span>Total Fcs</span>
                </th>

            </tr>
        </thead>

        <tbody class="table-body">
            @if(depositReport.length > 0){
            @for(row of depositReport; track row){
            <tr>
                @if(row?.districs !== 'UNKNOWN'){

                <td class="hover-item" (click)="onDistrictClick(row?.districs)">
                    {{row?.districs}}
                </td>
                <td>
                    {{row?.totalFcs}}
                </td>
            }
            </tr>
            }
            }@else {
            <tr>
                <td colspan="5" style="text-align: center;">
                    No records found
                </td>
            </tr>
            }
        </tbody>

    </table>

</div>
}@else if(showReportType === 'DISTRICTS'){
<div class="table-container">
    <table class="table">
        <thead class="table-head">
            <tr>
                <th>
                    <span>Pincode</span>
                </th>
                <th>
                    <span>Total Fcs</span>
                </th>
            </tr>
        </thead>

        <tbody class="table-body">
            @if(depositReport.length > 0){
            @for(row of depositReport; track row){

            <tr>
                <td>
                    {{row?.pincode}}
                </td>
                <td>
                    {{row?.totalFcs}}
                </td>
            </tr>
            }
            }@else {
            <tr>
                <td colspan="5" style="text-align: center;">
                    No records found
                </td>
            </tr>
            }
        </tbody>

    </table>

</div>
}
}@else {
@if(showReportType === 'COUNTRIES'){
@if(depositReport.length > 0){
@for(row of depositReport;track row;){

<div class="dp-card">
    @if(row?.states !== 'UNKNOWN'){

    <div class="heading d-flex justify-content-between">
        <span class="card-title hover-item" (click)="onStateClick(row?.states)">{{row?.states}}</span>
        <img src="../../../../../assets/images/dashboard-mob.svg" (click)="onStateClick(row?.states)">
    </div>
    <div class="mob-details-div">
        <div class="d-flex justify-content-between  grid-div">
            <span class="card-text-left">Total FCs</span>
            <span class="card-text-right">{{row?.totalFcs}}</span>
        </div>
    </div>
}
</div>
}
}@else{
<div class="dp-card align-items-center">
    <div class="heading d-flex justify-content-between ">
        <span class="card-title">No records found</span>
    </div>
</div>
}
}
@else if(showReportType === 'STATES'){
@if(depositReport.length > 0){
@for(row of depositReport;track row;){

<div class="dp-card">
    @if(row?.districs !== 'UNKNOWN'){

    <div class="heading d-flex justify-content-between">
        <span class="card-title hover-item" (click)="onDistrictClick(row?.districs)">{{row?.districs}}</span>
        <img src="../../../../../assets/images/dashboard-mob.svg" (click)="onDistrictClick(row?.districs)">
    </div>
    <div class="mob-details-div">
        <div class="d-flex justify-content-between  grid-div">
            <span class="card-text-left">Total FCs</span>
            <span class="card-text-right ">{{row?.totalFcs}}</span>
        </div>
    </div>
}
</div>
}
}@else{
<div class="dp-card align-items-center">
    <div class="heading d-flex justify-content-between ">
        <span class="card-title">No records found</span>
    </div>
</div>
}
}
@else if(showReportType === 'DISTRICTS'){
@if(depositReport.length > 0){
@for(row of depositReport;track row;){

<div class="dp-card">
    <div class="heading d-flex justify-content-between">
        <span class="card-title">{{row?.pincode}}</span>
    </div>
    <div class="mob-details-div">
        <div class="d-flex justify-content-between  grid-div">
            <span class="card-text-left">Total FCs</span>
            <span class="card-text-right">{{row?.totalFcs}}</span>
        </div>
    </div>
</div>
}
}@else{
<div class="dp-card">
    <div class="heading d-flex justify-content-between align-items-center">
        <span class="card-title">No records found</span>

    </div>
</div>
}
}
}